export const TAB_NAME = {
  messages: 'Messages',
  contacts: 'Contacts',
  settings: 'Settings'
};
